// ── 연차 관리 스타일 파트A (페이지·헤더·테이블·모바일카드) ──────────────────────

// 페이지 레이아웃
export const pageWrapStyle = {
  display: 'grid',
  gap: 10,
  padding: '4px 0',
};

// 페이지 헤더 카드 (전체 어드민 통일 스타일)
export const pageHeaderCard = {
  background: 'var(--bg-card)', borderRadius: 12, border: '1px solid var(--border)',
  padding: '8px 14px',
};
// 모바일도 row 유지 — 제목+회사칩(왼쪽 flex:1) + 아이콘(marginLeft:auto, shrink:0) 한 줄
// (이전: 모바일은 column으로 쌓여 두 줄 → 사용자 피드백으로 row 통일)
export const pageHeaderInner = () => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  gap: 8,
});
export const pageTitleStyle = {
  margin: 0,
  fontSize: 16,
  fontWeight: 900,
  color: 'var(--text)',
};

// 재직중/전체 토글 버튼
export const toggleGroupStyle = { display: 'flex', gap: 4, background: 'var(--bg-subtle)', padding: 3, borderRadius: 10 };
export const toggleBtn = (active) => ({
  border: 'none',
  borderRadius: 8,
  padding: '6px 14px',
  cursor: 'pointer',
  fontWeight: 700,
  fontSize: 13,
  background: active ? 'var(--bg-card)' : 'transparent',
  color: active ? 'var(--text-sub)' : 'var(--text-muted)',
  transition: 'all 0.15s',
});

// 카드 (섹션 컨테이너)
export const cardStyle = {
  background: 'var(--bg-card)',
  border: '1px solid var(--border)',
  borderRadius: 14,
  padding: 10,
  display: 'grid',
  gap: 8,
};

// 섹션 타이틀 (카드 내부)
export const sectionTitleStyle = {
  fontSize: 13,
  fontWeight: 800,
  color: 'var(--text-sub)',
  margin: 0,
};

// 액션 바
export const actionBarStyle = (isMobile) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: isMobile ? 'stretch' : 'center',
  flexDirection: isMobile ? 'column' : 'row',
  gap: 8,
  flexWrap: 'wrap',
});
export const actionBtnsStyle = (isMobile) => ({
  display: 'flex',
  gap: 6,
  flexWrap: 'wrap',
  width: isMobile ? '100%' : 'auto',
});

// 테이블
export const tableScrollStyle = {
  overflowX: 'auto',
  borderRadius: 10,
  border: '1px solid var(--border)',
};
export const tableBaseStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  tableLayout: 'fixed',
};
export const thStyle = {
  background: 'var(--bg-subtle)',
  padding: '6px 10px',
  textAlign: 'left',
  fontSize: 12,
  fontWeight: 700,
  color: 'var(--text-sub)',
  borderBottom: '1px solid var(--border)',
  whiteSpace: 'nowrap',
  position: 'sticky',
  top: 0,
  zIndex: 1,
};
export const tdStyle = {
  padding: '4px 10px',
  fontSize: 13,
  color: 'var(--text-sub)',
  borderBottom: '1px solid var(--bg-subtle)',
  verticalAlign: 'middle',
};
export const trHoverStyle = {};
export const emptyTdStyle = {
  padding: '24px 12px',
  textAlign: 'center',
  color: 'var(--text-muted)',
  fontSize: 13,
};
export const emptyTextStyle = {
  padding: 16,
  textAlign: 'center',
  color: 'var(--text-muted)',
  fontSize: 13,
};

// 행 스타일: 정정됨/자동생성 구분
// 자동생성 배경은 rgba로 라이트/다크 자동 대응 (mobileRowCard와 톤 일치)
// color 미지정 — 기본 텍스트 색 상속으로 다크모드 가독성 보장
export const detailRowStyle = (isCorrection, isGenerated) => {
  if (isCorrection) return { opacity: 0.52, textDecoration: 'line-through' };
  if (isGenerated)  return { background: 'rgba(14,165,233,0.08)' };
  return {};
};

// 모바일 카드 (요약)
export const summaryCardStyle = {
  border: '1px solid var(--border)',
  borderRadius: 10,
  padding: 8,
  background: 'var(--bg-card)',
  display: 'grid',
  gap: 8,
};
export const summaryCardHeadStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 8,
};
export const summaryCardGridStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 6,
};
export const summaryStatItemStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
};
export const summaryStatKeyStyle = {
  fontSize: 11,
  fontWeight: 700,
  color: 'var(--text-muted)',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};
export const summaryStatValStyle = {
  fontSize: 14,
  fontWeight: 700,
  color: 'var(--text-sub)',
};

// 모바일 내역 카드
export const mobileRowCard = (isCorrection, isGenerated) => ({
  border: '1px solid var(--border)',
  borderRadius: 10,
  padding: 8,
  background: isGenerated ? 'rgba(14,165,233,0.08)' : 'var(--bg-card)',
  display: 'grid',
  gap: 6,
  opacity: isCorrection ? 0.55 : 1,
  textDecoration: isCorrection ? 'line-through' : 'none',
});
export const mobileActionRowStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 6,
  marginTop: 2,
};
